<template>
    <span v-if="row.SGKBranchName">{{ row.SGKBranchName }}</span>
    <div v-else class="d-flex align-items-center">
        <span class="mr-auto font-weight-bolder text-danger">-</span>
        <span class="material-icons-outlined d-block text-danger font-size-16" v-b-tooltip.noninteractive.hover.bottom="`TMS'de ${row.SGKBranchRegistrationNumber} sicil numarası ile kayıtlı bir SGK şubesi bulunamadı.`">info</span>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
    props:{
        row:Object,
    },
    directives:{
        'b-tooltip':VBTooltip
    }
}
</script>

<style>
.font-size-16{
    font-size: 16px;
}
</style>